<div *ngIf="!insideIframe">
    <div class="m-story-tools">
        <ul class="l-story-tools">
            <ng-content></ng-content>
        </ul>
      </div>
      
</div>